/**
 * Copyright 2024 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export enum ReservationUtilizationTimePeriod {
  OneMonth = "ONE_MONTH",
  ThreeMonths = "THREE_MONTHS",
  TwelveMonths = "TWELVE_MONTHS",
}
